import { JobOverview } from "./JobOverview";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";
import { Job } from "@/types";

export const JobOverviewDialog = ({
  companyName,
  job,
  onOpenChange,
  open,
}: {
  companyName: string;
  job: Job;
  onOpenChange: (open: boolean) => void;
  open: boolean;
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-h-[90vh] max-w-5xl overflow-y-auto"
        onOpenAutoFocus={(e) => {
          e.preventDefault();
        }}
      >
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold text-slate-700">
            {job.title}
          </DialogTitle>
        </DialogHeader>
        <JobOverview
          companyName={companyName}
          job={job}
          screenName={MIXPANEL_SCREENS.CANDIDATE_SHEET}
        />
      </DialogContent>
    </Dialog>
  );
};
